import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../utilities/axiosInstance";

const initialState = {
  isLoading: false,
  data: [],
  itemsCount: 0,
  pages: 0,
  error: null,
};

export const getPromo = createAsyncThunk(
  "promo/getPromo",
  async (args, thunkApi) => {
    try {
      const { page = 1, size = 10 } = args || {};
      const { data } = await axiosInstance.get(
        `/promo?page=${page}&size=${size}`
      );
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response?.data || { message: "error" });
    }
  }
);

export const createPromo = createAsyncThunk(
  "promo/createPromo",
  async (args, thunkApi) => {
    try {
      const { data } = await axiosInstance.post(`/promo`, args);
      return thunkApi.fulfillWithValue(data);
    } catch (e) {
      return thunkApi.rejectWithValue(e.response?.data || { message: "error" });
    }
  }
);

export const deactivatePromo = createAsyncThunk(
  "promo/deactivatePromo",
  async (args, thunkApi) => {
    try {
      const { id } = args;
      const { data } = await axiosInstance.delete(`/promo/${id}`);
      return thunkApi.fulfillWithValue({ ...data, _id: id });
    } catch (e) {
      return thunkApi.rejectWithValue(e.response?.data || { message: "error" });
    }
  }
);

const promoSlice = createSlice({
  name: "promo",
  initialState,
  extraReducers: (b) => {
    b.addCase(getPromo.pending, (s) => {
      s.isLoading = true;
      s.error = null;
    })
      .addCase(getPromo.fulfilled, (s, { payload }) => {
        s.isLoading = false;
        s.data = payload.data?.data || [];
        s.itemsCount = payload.data?.itemsCount || 0;
        s.pages = payload.data?.pages || 0;
      })
      .addCase(getPromo.rejected, (s, { payload }) => {
        s.isLoading = false;
        s.error = payload?.message;
      })

      .addCase(createPromo.pending, (s) => {
        s.isLoading = true;
        s.error = null;
      })
      .addCase(createPromo.fulfilled, (s) => {
        s.isLoading = false;
      })
      .addCase(createPromo.rejected, (s, { payload }) => {
        s.isLoading = false;
        s.error = payload?.message;
      })

      .addCase(deactivatePromo.pending, (s) => {
        s.isLoading = true;
        s.error = null;
      })
      .addCase(deactivatePromo.fulfilled, (s, { payload }) => {
        s.isLoading = false;
        s.data = s.data.filter((x) => x._id !== payload._id);
      })
      .addCase(deactivatePromo.rejected, (s, { payload }) => {
        s.isLoading = false;
        s.error = payload?.message;
      });
  },
});

export default promoSlice.reducer;
